<template>
    <div id="pageAll">
        <div id="all">
            <botPageLeft :indexArr="[1,0]" @title="getData"/>
            <div class="contAll">
                <div class="menuTitle">
                    <div class="title1">{{titleArr[0]}} ></div>
                    <div class="title2">{{titleArr[1]}}</div>
                </div>
                <div class="content" v-for="(item,index) in contArr" :key="index">
                    <div class="title" :style="{color:item.sign?'#FF0000':''}">{{item.title}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import botPageLeft from '../../components/botPageLeft.vue'
export default {
  name: 'billExplain',
  components: { botPageLeft },
  data () {
    return {
      titleArr: [],
      contArr: [
        { title: '1.全新机器，现场拆封', sign: false },
        { title: '2.全新耗材（碳粉，硒鼓）现场拆封，现场安装。', sign: false },
        { title: '3.通电后确认计数器起始数字为0', sign: false },
        { title: '4.打印测试页无效果问题', sign: false },
        { title: '5.以上确认后视验收完毕', sign: false }
      ]
    }
  },
  methods: {
    getData (e) {
      console.log(e)
      this.titleArr = e
    }
  }
}
</script>

<style scoped="scoped">
    .contAll{
        width: 997px;
        min-height: 800px;
        background: #fff;
        padding: 40px;
        box-sizing: border-box;
    }
    .content{
        margin-top: 20px;
    }
    .title{
        font-size: 14px;
        font-weight: 700;
        color: #666;
        line-height: 28px;
    }
</style>
